export default __webpack_public_path__ + "static/media/logo.c1d9a65a.png";